import type { Project } from '../types/project';

/**
 * The one-line form of Preparer Information, shown on Project Info when the
 * profile has already filled the block in. The fields stay a click away;
 * the summary is what a contractor reads on every job after the first.
 */

export function preparerComplete(project: Partial<Project>): boolean {
  return Boolean((project.prepared_by ?? '').trim() && (project.preparer_email ?? '').trim());
}

export function preparerSummaryLines(project: Partial<Project>): string[] {
  const who = [
    (project.prepared_by ?? '').trim(),
    (project.preparer_title ?? '').trim(),
  ].filter(Boolean).join(', ');
  const lic = (project.preparer_license ?? '').trim();
  const email = (project.preparer_email ?? '').trim();
  const company = (project.company_name ?? '').trim();
  const address = [
    (project.company_address ?? '').trim(),
    [(project.company_city ?? '').trim(), (project.company_state ?? '').trim()].filter(Boolean).join(', '),
    (project.company_zip ?? '').trim(),
  ].filter(Boolean).join(' · ');
  const date = project.report_date
    ? new Date(project.report_date + 'T00:00:00').toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
    : '';

  const first = [who, lic ? `Lic. ${lic}` : '', email].filter(Boolean).join(' · ');
  const second = [company, address].filter(Boolean).join(' · ');
  const third = date ? `Report date ${date}` : '';
  return [first, second, third].filter(Boolean);
}
